export default __webpack_public_path__ + "static/media/img-b-02-charging-bg@2x.6075b7c5.png";